import { render } from "./cookieFooter.vue?vue&type=template&id=45ae6852&ts=true"
import script from "./cookieFooter?vue&type=script&lang=ts"
export * from "./cookieFooter?vue&type=script&lang=ts"

import "./_assets/_cookie-footer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__